// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderSeller,
    ProviderSellerSortType,
    SupportCreateSellerPayload,
    SupportReplaceSellerPayload,
    SupportSeller,
    SupportSellerSortType,
    SupportUpdateSellerPayload,
    SupportCreateSellerPayloadToJSON,
    SupportReplaceSellerPayloadToJSON,
    SupportUpdateSellerPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderSellerFromJSON,
    SupportSellerFromJSON,
} from '../models';

export interface CreateSupportSellerRequest {
    supportCreateSellerPayload: SupportCreateSellerPayload;
}

export interface DisableSupportSellerRequest {
    id: string;
}

export interface GetProviderSellerRequest {
    id: string;
}

export interface GetSupportSellerRequest {
    id: string;
}

export interface ListProviderSellersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderSellersOrderEnum>;
    filterCreated?: Array<string>;
    filterExternalId?: Array<string>;
    filterOrganization?: Array<string>;
    filterFirst?: Array<string>;
    filterMiddle?: Array<string>;
    filterLast?: Array<string>;
    filterSuffix?: Array<string>;
    filterFirstLast?: Array<string>;
    sort?: Array<ProviderSellerSortType>;
}

export interface ListSupportSellersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportSellersOrderEnum>;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterTag?: Array<string>;
    filterExternalId?: Array<string>;
    filterOrganization?: Array<string>;
    filterFirst?: Array<string>;
    filterMiddle?: Array<string>;
    filterLast?: Array<string>;
    filterSuffix?: Array<string>;
    filterFirstLast?: Array<string>;
    sort?: Array<SupportSellerSortType>;
}

export interface ReplaceSupportSellerRequest {
    supportReplaceSellerPayload: SupportReplaceSellerPayload;
}

export interface UpdateSupportSellerRequest {
    id: string;
    supportUpdateSellerPayload: SupportUpdateSellerPayload;
}

/**
 * no description
 */
export class SellerApi extends runtime.BaseAPI {

    /**
     * Creates a seller
     * Create a seller
     */
    async createSupportSellerRaw(requestParameters: CreateSupportSellerRequest): Promise<runtime.ApiResponse<SupportSeller>> {
        if (requestParameters['supportCreateSellerPayload'] === null || requestParameters['supportCreateSellerPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreateSellerPayload','Required parameter requestParameters.supportCreateSellerPayload was null or undefined when calling createSupportSeller.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:seller", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/seller`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreateSellerPayloadToJSON(requestParameters['supportCreateSellerPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportSellerFromJSON(jsonValue));
    }

    /**
     * Creates a seller
     * Create a seller
     */
    async createSupportSeller(requestParameters: CreateSupportSellerRequest): Promise<SupportSeller> {
        const response = await this.createSupportSellerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a seller
     * Disable a seller
     */
    async disableSupportSellerRaw(requestParameters: DisableSupportSellerRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportSeller.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:seller", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/seller/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a seller
     * Disable a seller
     */
    async disableSupportSeller(requestParameters: DisableSupportSellerRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportSellerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a seller
     * Get a seller
     */
    async getProviderSellerRaw(requestParameters: GetProviderSellerRequest): Promise<runtime.ApiResponse<ProviderSeller>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderSeller.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:seller"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/seller/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderSellerFromJSON(jsonValue));
    }

    /**
     * Gets a seller
     * Get a seller
     */
    async getProviderSeller(requestParameters: GetProviderSellerRequest): Promise<ProviderSeller> {
        const response = await this.getProviderSellerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a seller
     * Get a seller
     */
    async getSupportSellerRaw(requestParameters: GetSupportSellerRequest): Promise<runtime.ApiResponse<SupportSeller>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportSeller.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:seller", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/seller/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportSellerFromJSON(jsonValue));
    }

    /**
     * Gets a seller
     * Get a seller
     */
    async getSupportSeller(requestParameters: GetSupportSellerRequest): Promise<SupportSeller> {
        const response = await this.getSupportSellerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sellers
     * Get a list of sellers
     */
    async listProviderSellersRaw(requestParameters: ListProviderSellersRequest): Promise<runtime.ApiResponse<Array<ProviderSeller>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterOrganization) {
            queryParameters['filterOrganization'] = requestParameters.filterOrganization;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterMiddle) {
            queryParameters['filterMiddle'] = requestParameters.filterMiddle;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterSuffix) {
            queryParameters['filterSuffix'] = requestParameters.filterSuffix;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:seller"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/seller`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderSellerFromJSON));
    }

    /**
     * Gets a list of sellers
     * Get a list of sellers
     */
    async listProviderSellers(requestParameters: ListProviderSellersRequest): Promise<Array<ProviderSeller>> {
        const response = await this.listProviderSellersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of sellers
     * Get a list of sellers
     */
    async listSupportSellersRaw(requestParameters: ListSupportSellersRequest): Promise<runtime.ApiResponse<Array<SupportSeller>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterTag) {
            queryParameters['filterTag'] = requestParameters.filterTag;
        }

        if (requestParameters.filterExternalId) {
            queryParameters['filterExternalId'] = requestParameters.filterExternalId;
        }

        if (requestParameters.filterOrganization) {
            queryParameters['filterOrganization'] = requestParameters.filterOrganization;
        }

        if (requestParameters.filterFirst) {
            queryParameters['filterFirst'] = requestParameters.filterFirst;
        }

        if (requestParameters.filterMiddle) {
            queryParameters['filterMiddle'] = requestParameters.filterMiddle;
        }

        if (requestParameters.filterLast) {
            queryParameters['filterLast'] = requestParameters.filterLast;
        }

        if (requestParameters.filterSuffix) {
            queryParameters['filterSuffix'] = requestParameters.filterSuffix;
        }

        if (requestParameters.filterFirstLast) {
            queryParameters['filterFirstLast'] = requestParameters.filterFirstLast;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:seller", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/seller`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportSellerFromJSON));
    }

    /**
     * Gets a list of sellers
     * Get a list of sellers
     */
    async listSupportSellers(requestParameters: ListSupportSellersRequest): Promise<Array<SupportSeller>> {
        const response = await this.listSupportSellersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a seller
     * Replace a seller
     */
    async replaceSupportSellerRaw(requestParameters: ReplaceSupportSellerRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplaceSellerPayload'] === null || requestParameters['supportReplaceSellerPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplaceSellerPayload','Required parameter requestParameters.supportReplaceSellerPayload was null or undefined when calling replaceSupportSeller.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:seller", "support:grant", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/seller/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplaceSellerPayloadToJSON(requestParameters['supportReplaceSellerPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a seller
     * Replace a seller
     */
    async replaceSupportSeller(requestParameters: ReplaceSupportSellerRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportSellerRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a seller
     * Update a seller
     */
    async updateSupportSellerRaw(requestParameters: UpdateSupportSellerRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportSeller.');
        }

        if (requestParameters['supportUpdateSellerPayload'] === null || requestParameters['supportUpdateSellerPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdateSellerPayload','Required parameter requestParameters.supportUpdateSellerPayload was null or undefined when calling updateSupportSeller.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:seller", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/seller/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdateSellerPayloadToJSON(requestParameters['supportUpdateSellerPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a seller
     * Update a seller
     */
    async updateSupportSeller(requestParameters: UpdateSupportSellerRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportSellerRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderSellersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportSellersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
